export function u3204BuildAcceptAttribute(allowedMimeTypes: string[]): string {
  return allowedMimeTypes.join(',');
}
